import React, { FunctionComponent } from 'react';

const breakpoints: string[] = ['xs', 'sm', 'md', 'lg', 'xlg'];

const createClasses = (prefix: string, cols: (number | null)[]) => {
    return cols.reduce((classes: string[], col, i) => {
        classes.push(i === 0 ? `${prefix}-${col}` : `${prefix}-${col}--${breakpoints[i]}`);

        return classes;
    }, []);
};

interface ColInterface {
    extraClass?: string;
    cols?: (number | null)[];
    push?: (number | null)[];
    pull?: (number | null)[];
    pre?: (number | null)[];
    post?: (number | null)[];
}

export const Column: FunctionComponent<ColInterface> = ({
    extraClass = '',
    children,
    cols = [],
    push = [],
    pull = [],
    pre = [],
    post = [],
}) => {
    const classes: string = [
        ...createClasses('o-col', cols),
        ...createClasses('u-push', push),
        ...createClasses('u-pull', pull),
        ...createClasses('u-pre', pre),
        ...createClasses('u-post', post),
    ].join(' ');

    return <div className={`${classes} ${extraClass}`}>{children}</div>;
};
